// import Header from "../components/Common/Header";
import ScrollAnimationBoxes from "../components/Card/ScrollAnimationBoxes";
import TextEffectSplite from "../components/Text/TextEffectSplite";
import BoxThree from "../components/Card/BoxThree";

export default function FeaturesScreen() {
  return (
    <>
      {/* <Header /> */}
      <BoxThree />
      <ScrollAnimationBoxes />
      <TextEffectSplite />
    </>
  );
}
